module.exports = __webpack_public_path__ + "img/icon_package@2x(3).d23d4c74.png";